import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Header";

const ROLE = { service_writer: "Service writer", technician: "Technician" };

export default function JoinShop() {
  const { token } = useParams();
  const { user, checkAuth } = useAuth();
  const navigate = useNavigate();
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/invites/${token}`).then((r) => setInv(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);

  const accept = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/invites/${token}/accept`); await checkAuth(); toast.success(`Welcome to ${data.shop_name}`); navigate("/app"); }
    catch (e) { setErr(errMsg(e)); } finally { setBusy(false); }
  };
  const next = encodeURIComponent(`/join/${token}`);

  return (
    <div className="min-h-screen grid place-items-center grid-bg px-4">
      <div className="bg-card border border-border rounded-sm p-10 max-w-md w-full space-y-5" data-testid="join-page">
        <Logo />
        {!inv && !err && <Loader2 className="h-6 w-6 animate-spin text-primary" />}
        {err && <p className="text-red-400 text-sm" data-testid="join-error">{err}</p>}
        {inv && (
          <>
            <Users className="h-8 w-8 text-primary" />
            <h1 className="text-3xl font-extrabold uppercase leading-tight" data-testid="join-title">Join {inv.shop_name}</h1>
            <p className="text-sm text-muted-foreground">You're invited as a <b className="text-white">{ROLE[inv.role]}</b>. This invite is for <span className="font-mono">{inv.email}</span>.</p>
            {user === null && <Loader2 className="h-5 w-5 animate-spin" />}
            {user === false && (
              <div className="flex gap-3">
                <Button asChild className="rounded-sm flex-1 hover:bg-orange-600 hover:text-white" data-testid="join-signin-btn"><Link to={`/login?next=${next}`}>Sign in or sign up</Link></Button>
              </div>
            )}
            {user && (
              <>
                <p className="text-xs text-muted-foreground">Signed in as <span className="font-mono">{user.email}</span></p>
                <Button onClick={accept} disabled={busy} className="w-full h-11 rounded-sm font-semibold hover:bg-orange-600 hover:text-white" data-testid="join-accept-btn">
                  {busy ? "Joining..." : "Accept invite"}
                </Button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
